var _excluded = ["encryptedKey"],
    _excluded2 = ["encryptedKey"];
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { wrap as aesKw } from '../runtime/aeskw.js';
import * as ECDH from '../runtime/ecdhes.js';
import { encrypt as pbes2Kw } from '../runtime/pbes2kw.js';
import { encrypt as rsaEs } from '../runtime/rsaes.js';
import { encode as base64url } from '../runtime/base64url.js';
import generateCek, { bitLength as cekLength } from '../lib/cek.js';
import { JOSENotSupported } from '../util/errors.js';
import { exportJWK } from '../key/export.js';
import checkKeyType from './check_key_type.js';
import { wrap as aesGcmKw } from './aesgcmkw.js';

function encryptKeyManagement(_x, _x2, _x3, _x4) {
  return _encryptKeyManagement.apply(this, arguments);
}

function _encryptKeyManagement() {
  _encryptKeyManagement = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(alg, enc, key, providedCek) {
    var providedParameters,
        encryptedKey,
        parameters,
        cek,
        apu,
        apv,
        ephemeralKey,
        _yield$exportJWK,
        x,
        y,
        crv,
        kty,
        sharedSecret,
        kwAlg,
        p2c,
        p2s,
        _yield$pbes2Kw,
        iv,
        _yield$aesGcmKw,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            providedParameters = _args.length > 4 && _args[4] !== undefined ? _args[4] : {};
            checkKeyType(alg, key, 'encrypt');
            _context.t0 = alg;
            _context.next = _context.t0 === 'dir' ? 5 : _context.t0 === 'ECDH-ES' ? 7 : _context.t0 === 'ECDH-ES+A128KW' ? 7 : _context.t0 === 'ECDH-ES+A192KW' ? 7 : _context.t0 === 'ECDH-ES+A256KW' ? 7 : _context.t0 === 'RSA1_5' ? 39 : _context.t0 === 'RSA-OAEP' ? 39 : _context.t0 === 'RSA-OAEP-256' ? 39 : _context.t0 === 'RSA-OAEP-384' ? 39 : _context.t0 === 'RSA-OAEP-512' ? 39 : _context.t0 === 'PBES2-HS256+A128KW' ? 44 : _context.t0 === 'PBES2-HS384+A192KW' ? 44 : _context.t0 === 'PBES2-HS512+A256KW' ? 44 : _context.t0 === 'A128KW' ? 52 : _context.t0 === 'A192KW' ? 52 : _context.t0 === 'A256KW' ? 52 : _context.t0 === 'A128GCMKW' ? 57 : _context.t0 === 'A192GCMKW' ? 57 : _context.t0 === 'A256GCMKW' ? 57 : 65;
            break;

          case 5:
            cek = key;
            return _context.abrupt("break", 66);

          case 7:
            if (ECDH.ecdhAllowed(key)) {
              _context.next = 9;
              break;
            }

            throw new JOSENotSupported('ECDH with the provided key is not allowed or not supported by your javascript runtime');

          case 9:
            apu = providedParameters.apu, apv = providedParameters.apv;
            ephemeralKey = providedParameters.epk;
            _context.t1 = ephemeralKey;

            if (_context.t1) {
              _context.next = 16;
              break;
            }

            _context.next = 15;
            return ECDH.generateEpk(key);

          case 15:
            ephemeralKey = _context.sent.privateKey;

          case 16:
            _context.next = 18;
            return exportJWK(ephemeralKey);

          case 18:
            _yield$exportJWK = _context.sent;
            x = _yield$exportJWK.x;
            y = _yield$exportJWK.y;
            crv = _yield$exportJWK.crv;
            kty = _yield$exportJWK.kty;
            _context.next = 25;
            return ECDH.deriveKey(key, ephemeralKey, alg === 'ECDH-ES' ? enc : alg, alg === 'ECDH-ES' ? cekLength(enc) : parseInt(alg.slice(-5, -2), 10), apu, apv);

          case 25:
            sharedSecret = _context.sent;
            parameters = {
              epk: {
                x: x,
                crv: crv,
                kty: kty
              }
            };
            if (kty === 'EC') parameters.epk.y = y;
            if (apu) parameters.apu = base64url(apu);
            if (apv) parameters.apv = base64url(apv);

            if (!(alg === 'ECDH-ES')) {
              _context.next = 33;
              break;
            }

            cek = sharedSecret;
            return _context.abrupt("break", 66);

          case 33:
            cek = providedCek || generateCek(enc);
            kwAlg = alg.slice(-6);
            _context.next = 37;
            return aesKw(kwAlg, sharedSecret, cek);

          case 37:
            encryptedKey = _context.sent;
            return _context.abrupt("break", 66);

          case 39:
            cek = providedCek || generateCek(enc);
            _context.next = 42;
            return rsaEs(alg, key, cek);

          case 42:
            encryptedKey = _context.sent;
            return _context.abrupt("break", 66);

          case 44:
            cek = providedCek || generateCek(enc);
            p2c = providedParameters.p2c, p2s = providedParameters.p2s;
            _context.next = 48;
            return pbes2Kw(alg, key, cek, p2c, p2s);

          case 48:
            _yield$pbes2Kw = _context.sent;
            encryptedKey = _yield$pbes2Kw.encryptedKey;
            parameters = _objectWithoutProperties(_yield$pbes2Kw, _excluded);
            return _context.abrupt("break", 66);

          case 52:
            cek = providedCek || generateCek(enc);
            _context.next = 55;
            return aesKw(alg, key, cek);

          case 55:
            encryptedKey = _context.sent;
            return _context.abrupt("break", 66);

          case 57:
            cek = providedCek || generateCek(enc);
            iv = providedParameters.iv;
            _context.next = 61;
            return aesGcmKw(alg, key, cek, iv);

          case 61:
            _yield$aesGcmKw = _context.sent;
            encryptedKey = _yield$aesGcmKw.encryptedKey;
            parameters = _objectWithoutProperties(_yield$aesGcmKw, _excluded2);
            return _context.abrupt("break", 66);

          case 65:
            throw new JOSENotSupported('Invalid or unsupported "alg" (JWE Algorithm) header value');

          case 66:
            return _context.abrupt("return", {
              cek: cek,
              encryptedKey: encryptedKey,
              parameters: parameters
            });

          case 67:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _encryptKeyManagement.apply(this, arguments);
}

export default encryptKeyManagement;